"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSchedule = void 0;
const date_time_utils_1 = require("./date-time.utils");
const types_1 = require("./types");
const START_YEAR = 2000;
const END_YEAR = 2001;
/**
 * Checks if two activity times overlap.
 * @param first - The first activity time.
 * @param second - The second activity time.
 * @returns A boolean indicating whether the activity times overlap.
 */
function checkOverlappingActivityTimes(first, second) {
    if (first.availabilityStartDate > second.availabilityEndDate || first.availabilityEndDate < second.availabilityStartDate) {
        return false;
    }
    if (first.dayOfWeek !== second.dayOfWeek) {
        return false;
    }
    if (first.close <= second.open || first.open >= second.close) {
        return false;
    }
    return true;
}
/**
 * Validates the schedule by checking for overlapping activity times.
 *
 * @param activityTimes - An array of activity times to validate.
 * @param breakOnFirst - A boolean indicating whether to break on the first error.
 * @returns A boolean indicating whether the schedule is valid or not.
 */
function validateSchedule(activityTimes, breakOnFirst = false) {
    const problematicActivityTimes = [];
    const convertedActivityTimes = convertActivityTimes(activityTimes);
    for (const [index, activityTime] of convertedActivityTimes.entries()) {
        for (const [checkIndex, checkActivityTime] of convertedActivityTimes.entries()) {
            if (index === checkIndex) {
                continue;
            }
            if (checkOverlappingActivityTimes(activityTime, checkActivityTime)) {
                problematicActivityTimes.push(activityTimes[checkIndex]);
                if (breakOnFirst) {
                    return problematicActivityTimes;
                }
            }
        }
    }
    return problematicActivityTimes;
}
exports.validateSchedule = validateSchedule;
/**
 * Converts an array of `ActivityTimeDto` objects to an array of `ConvertedActivityTimeDto` objects.
 * @param activityTimes - The array of `ActivityTimeDto` objects to convert.
 * @returns An array of `ConvertedActivityTimeDto` objects.
 */
function convertActivityTimes(activityTimes) {
    return activityTimes.map(activityTime => {
        const year = (0, date_time_utils_1.getEndAvailabilityYear)(activityTime);
        return {
            ...activityTime,
            availabilityStartDate: activityTime.availabilityStartDate ? (0, date_time_utils_1.convertToDate)(activityTime.availabilityStartDate) : (0, date_time_utils_1.convertToDate)(types_1.DefaultDatesEnum.START_DATE),
            availabilityEndDate: activityTime.availabilityEndDate ? (0, date_time_utils_1.convertToDate)(activityTime.availabilityEndDate, year) : (0, date_time_utils_1.convertToDate)(types_1.DefaultDatesEnum.END_DATE, year),
            open: (0, date_time_utils_1.parseTime)(activityTime.open),
            close: (0, date_time_utils_1.parseTime)(activityTime.close),
        };
    });
}
//# sourceMappingURL=schedule.validation.js.map